export const firebaseConfig = {
  apiKey: "AIzaSyBLTZkgJWOVXgOphUA3HkbD1XX3Woli6bQ",
  authDomain: "fir-wave-plus.firebaseapp.com",
  projectId: "fir-wave-plus",
  storageBucket: "fir-wave-plus.appspot.com",
  messagingSenderId: "944899797049",
  appId: "1:944899797049:web:f4548d24915ec2b3551de8"
};
